/* import __COLOCATED_TEMPLATE__ from './message-type-quick-action-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();